export const responsive = (
  normalSize: any,
  largeSize: any,
  ExtraLarge: any
) => {
  return `
    xl-low:${normalSize} xl-mid:${largeSize} xl-high:${ExtraLarge}
  xl-high:bg-green-300 
  xl-mid:bg-yellow-300 
  xl-low:bg-red-300
    `;
};

export const btnResponsive = (value?: string) => {
  if (value === "text-lg") {
    return `${value} xl-low:text-lg xl-mid:text-[20px] xl-high:text-[23px] `;
  } else if (value === "text-xs") {
    return `${value} xl-low:text-xs xl-mid:text-[18px] xl-high:text-[22px]`;
  } else if (value === "text-sm") {
    return `${value} xl-low:text-sm xl-mid:text-[19px] xl-high:text-[21px]`;
  }
  else if (value === "text-base") {
    return `${value} xl-low:text-base xl-mid:text-[20px] xl-high:text-[35px]`;
  }
  else if (value === "icons") {
    return `${value} xl-low:text-xl xl-mid:text-2xl xl-high:text-3xl`;
  }
  else if (value === "panel-icons") {
    return `${value} h-[15px] w-[15px] xl-low:h-[18px] xl-low:w-[18px] xl-mid:h-[20px] xl-mid:w-[20px] xl-high:h-[25px] xl-high:w-[25px]`;
  }
  return `text-xs h-[1.5rem] xl-low:!h-[2rem] xl-mid:!h-[2.5rem] xl-high:!h-[3rem]  xl-mid:!text-[20px] xl-high:!text-[23px]`;
};

export const textResponsive = (value?: string) => {
  if (value === "text-xs") {
    return `${value} xl-low:${value} xl-mid:text-[15px] xl-high:text-[20px]`
  }
  else if (value === "text-sm") {
    return `${value} xl-low:${value} xl-mid:text-[18px] xl-high:text-[22px]`
  }
  else if (value === "text-base") {
    return `${value} xl-low:${value} xl-mid:text-[20px] xl-high:text-[25px]`
  }
  else if (value === "text-lg") {
    return `${value} xl-low:${value} xl-mid:text-[22px] xl-high:text-[34px]`
  }
  else if (value === "text-xl") {
    return `${value} xl-low:${value} xl-mid:text-[25px] xl-high:text-[36px]`
  }
  else if (value === "text-2xl") {
    return `${value} xl-low:${value} xl-mid:text-[30px] xl-high:text-[44px]`
  }
  else if (value === "text-3xl") {
    return `${value} xl-low:${value} xl-mid:text-[38px] xl-high:text-[56px]`
  }
  else if (value === "text-4xl") {
    return `${value} xl-low:${value} xl-mid:text-[45px] xl-high:text-[67px]`
  }
  else if (value === "text-5xl") {
    return `${value} xl-low:${value} xl-mid:text-[60px] xl-high:text-[91px]`
  }
  else if (value === "text-6xl") {
    return `${value} xl-low:${value} xl-mid:text-[75px] xl-high:text-[114px]`
  }
  else{
    return `text-xs h-[1.5rem] xl-low:!h-[2rem] xl-mid:!h-[2.5rem] xl-high:!h-[3rem]     w-[1.5rem] xl-low:!w-[2rem] xl-mid:!w-[2.5rem] xl-high:!w-[3rem]  xl-mid:!text-[20px] xl-high:!text-[23px]`
  }
}

// Dynamic responsive font size generator
export const getResponsiveFontSize = (basePx: number) => {
  const baseResolution = 1280;
  const midResolution = 1600;
  const highResolution = 2500;

  const midSize = Math.round((midResolution / baseResolution) * basePx);
  const highSize = Math.round((highResolution / baseResolution) * basePx) - 3;

  return `text-[${basePx}px] xl-low:text-[${basePx}px] xl-mid:text-[${midSize}px] xl-high:text-[${highSize}px]`;
};